<template>
<Layout :classes="classes" :header="headerBackgroundColor">
    <template v-html="content.head_override"></template>
    <Topper :data="content.topper.data"></Topper>
    <Slices :slices="content.slices" :class="{'with-background': !content.hide_content_background }"></Slices>
</Layout>
</template>

<script>

import { computed, onMounted, onUnmounted } from 'vue';
import Layout from './Layout.vue';
import Topper from './Slices/Topper.vue';
import Slices from './Slices.vue';

// https://stackoverflow.com/a/47614491
function setInnerHtml(elm, html) {
  elm.innerHTML = html;
  Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
    const newScript = document.createElement("script");
    Array.from(oldScript.attributes)
      .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

export default {

    components: {
        Topper,
        Slices,
        Layout
    },

    props: ['title', 'content', 'classes'],

    setup(props) {

        onMounted(() => {
            let container = document.getElementById('override-container');
            if (props.content.head_override) {
                setInnerHtml(container, props.content.head_override);
            }
        });

        onUnmounted(() => {
            let container = document.getElementById('override-container');
            container.innerHTML = '';
        });

        const headerBackgroundColor = computed(() => {
            if (props.content.topper.data.format == 'tall') {
                return 'dark';
            }
            return props.content?.topper?.data?.options?.color_scheme || 'light';
        });

        return {
            headerBackgroundColor
        };
        
    }

}
</script>